import React, { useContext, useEffect, useState } from 'react';
import { putData } from '../../lib/utils';
import { useParams } from 'react-router-dom';
import { Context } from '../contexts/AppContext';

const SettingsSideNav = () => {

    const { value } = useContext(Context);
    const [appState, setAppState] = value;  

  const {galleryId} = useParams()
  // Managing the state for each slide toggle
  const [toggles, setToggles] = useState([
    { label: "Downloads Button", isEnabled: false },
    { label: "Share Button", isEnabled: false },
    { label: "TV Connect Button", isEnabled: false },
    { label: "Play All Button", isEnabled: false },
  ]);
 
  //setToggles(appState.currentGalleryData.setting)
  useEffect(() => {
    const setting = appState?.currentGalleryData?.setting;
  
   
  
    if (setting) {
      const mappedToggles = [
        { label: "Downloads Button", isEnabled: setting.download },
        { label: "Share Button", isEnabled: setting.share },
        { label: "TV Connect Button", isEnabled: setting.tv },
        { label: "Play All Button", isEnabled: setting.playall },
      ];
      setToggles(mappedToggles);
    }
  }, [appState?.currentGalleryData?.setting]);
  

  const handleToggle = async(index) => {
    const newToggles = [...toggles];
    newToggles[index].isEnabled = !newToggles[index].isEnabled;
    setToggles(newToggles);

    console.log("NEW TOO ",newToggles)
    const obj ={};
    obj.download=newToggles[0].isEnabled
    obj.share=newToggles[1].isEnabled
    obj.tv=newToggles[2].isEnabled
    obj.playall=newToggles[3].isEnabled

    
    
              const json = await putData(`galleries/gallery/settings/${galleryId}`, {
                       "setting": obj
                      });
                      if (json) {    
                        setAppState((prevState) => ({
                          ...prevState,
                          currentGalleryData: {
                            ...prevState.currentGalleryData,
                            setting: json.gallery.setting,
                          },
                        }));
                        
                   
                      }
  };

  return (
    <form className="settings-container bg-gray-900 p-4">
      {toggles.map((toggle, index) => (
        <>
        <div key={index} className="flex justify-between">
          <div className="menu-label text-white text-sm">{toggle.label}</div>
          <label className="items-center cursor-pointer">
            <input
              type="checkbox"
              checked={toggle.isEnabled}
              onChange={() => handleToggle(index)}
              value=""
              className="sr-only peer"
            />
            <div className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none    dark:peer-focus:ring-yellow-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-yellow-800 dark:peer-checked:bg-yellow-800"></div>
            
          </label>
        </div>
            <hr className="my-3 border-gray-600" />
            </>
      ))}
  
    </form>
  );
};

export default SettingsSideNav;
